import { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const AdminUserPage = lazy(() => import("./admin-user/AdminUserPage"));
const AdminGroupPage = lazy(() => import("./admin-group/AdminGroupPage"));
const CustomerPage = lazy(() => import("./customer/CustomerPage"));
const MaterialPage = lazy(() => import("./material/MaterialPage"));
const MachinePage = lazy(() => import("./machine/MachinePage"));
const ToolPage = lazy(() => import("./tool/ToolPage"));
const CostParameterPage = lazy(() => import("./cost-parameter/CostParameterPage"));
const PricingRulePage = lazy(() => import("./pricing-rule/PricingRulePage"));
const QuotationPage = lazy(() => import("./quotation/QuotationPage"));
const WorkOrderPage = lazy(() => import("./work-order/WorkOrderPage"));
const KnowledgePage = lazy(() => import("./knowledge/KnowledgePage"));
const DiagnosticsPage = lazy(() => import("./diagnostics/DiagnosticsPage"));
const AiAccuracyPage = lazy(() => import("./ai-accuracy/AiAccuracyPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/customer" component={CustomerPage} />
                <Route path="/admin-user" component={AdminUserPage} />
                <Route path="/admin-group" component={AdminGroupPage} />

                <Route path="/material" component={MaterialPage} />
                <Route path="/machine" component={MachinePage} />
                <Route path="/tool" component={ToolPage} />
                <Route path="/cost-parameter" component={CostParameterPage} />
                <Route path="/pricing-rule" component={PricingRulePage} />
                <Route path="/quotation" component={QuotationPage} />
                <Route path="/work-order" component={WorkOrderPage} />
                <Route path="/knowledge" component={KnowledgePage} />
                <Route path="/diagnostics" component={DiagnosticsPage} />
                <Route path="/ai-accuracy" component={AiAccuracyPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
